// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.

document.cookie = `time_zone=${(new Date()).getTimezoneOffset()}`;

import * as Turbo from '@hotwired/turbo'
import TurboPower from 'turbo_power'
Turbo.start()
Turbo.session.drive = false
TurboPower.initialize(Turbo.StreamActions)

import Rails from '@rails/ujs';
Rails.start();

// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// TODO: Move to ..../assets
import "./style.css"
import "~/controllers"

// There are places we rely on path manipulation, and weird stuff happens if the path
// ends with a / (which would, in filesystem terms, be a directory).
function normalizeUrlPath() {
  const url = new URL(window.location.href)
  const path = url.pathname.endsWith("/") ? url.pathname.slice(0, -1) : url.pathname
  if (path !== url.pathname) {
    url.pathname = path
    window.history.replaceState({}, "", url.toString())
  }

}
normalizeUrlPath()

const timezoneOffset = (new Date()).getTimezoneOffset();
document.cookie = `time_zone=${timezoneOffset}; path=/;`